import React from "react"
import {useTranslation} from "react-i18next"

import {IonItem, IonItemDivider, IonItemGroup, IonLabel, IonNote} from "@ionic/react"

import TimeLimit from "../../../types/TimeLimit"

export interface componentProps {
    item: TimeLimit
}

const ViewItemGroupInfo: React.FC<componentProps> = ({item} ) => {

    const {t} = useTranslation()

    const keysCount: number = item.keyTimeLimits?.length || 0;
    const dataCount: number = item.timeLimitData?.length || 0;

    return (
        <IonItemGroup>
            <IonItemDivider>{t('common.linked')}</IonItemDivider>
            <IonItem lines="full" button detail
                     routerLink={'/time-limits/' + item.id + '/keys'}>
                <IonLabel>{t('keys.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{keysCount || '-'}</IonNote>
            </IonItem>
            <IonItem lines="full" button={dataCount > 0} detail={dataCount > 0}
                     routerLink={'/time-limits/' + item.id + '/time-limit-data'}>
                <IonLabel>{t('time-limit-data.title_list')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">{dataCount || '-'}</IonNote>
            </IonItem>
            {item.lockingSystemZone &&
            <IonItem lines="full" button detail routerLink={'/locking-system-zones/' + item.lockingSystemZone.id + '/view'}>
                <IonLabel>{t('locking-system-zones.title_item')}</IonLabel>
                <IonNote className="ion-padding-vertical" slot="end">1</IonNote>
            </IonItem>
            }
        </IonItemGroup>
    )
}

export default ViewItemGroupInfo